import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f2f2e5d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "login",
  class: "w-full h-full"
}
const _hoisted_2 = { id: "loginSidebar" }
const _hoisted_3 = { style: {"text-align":"center"} }

import {onMounted} from 'vue';
import {ErrorLocationType} from "@/utilities/enums/Enums";
import Error from "@/components/Error.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import AuthService from "@/utilities/services/AuthService";
import {MiscService} from "@/utilities/services/MiscService";
import {useGlobalStore} from "@/stores/GlobalStore";
import router from "@/router";
import {isDev} from "@/AppConfig";
import User from "@/models/entities/User";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const miscService = new MiscService();

onMounted (async ()=>{
  await miscService.setExternalCustomerLinks(ErrorLocationType.login);

  if(!isDev){
    const authService = AuthService.getDefaultInstance();
    await authService.login((useGlobalStore()).redirectAfterLogin);
  }

  (useGlobalStore()).user = new User({
    id: 1,
    email: "digi_th@digi3.de",
    firstName: "Digi",
    lastName: "Digi",
    role: "User"
  });
  await router.push("/dashboard")
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LoadingSpinner),
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).login,
          class: "mt-4"
        }, null, 8, ["errorLoc"])
      ])
    ])
  ]))
}
}

})